var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{key:_vm.field.prop,attrs:{"sortable":_vm.field.sortable ? 'custom' : false,"prop":_vm.field.prop,"label":_vm.field.label,"width":_vm.field.width,"formatter":_vm.formatDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }